/* eslint react/forbid-prop-types: 0, react/no-unused-prop-types: 0 */
/* global globals, translations */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import PaymentsStore from '../../stores/PaymentsStore';

const SubscriptionBlocks = (props) => {
  const { termsData, chosenOption } = props;
  const paymentTypes = Object.keys(termsData).filter((item) => Number(item));

  const result = [];

  const keyBase = 'subscription_block_key_base_';
  let counter = 1;
  paymentTypes.forEach((payment, index) => {
    const termData = termsData[payment];

    let badge = '';
    if (termData.badge) {
      switch (termData.badge) {
        case 'most-popular':
          badge = (
            <div className="paymentPeriod-badge paymentPeriod-badge--popular">
              <div className="paymentPeriod-badgeText">
                {get(translations, 'txt: populārākais', 'populārākais')}
              </div>
            </div>
          );
          break;
        case 'best-value':
          badge = (
            <div className="paymentPeriod-badge paymentPeriod-badge--bestvalue">
              <div className="paymentPeriod-badgeText">
                {get(translations, 'txt: izdevīgākais', 'izdevīgākais')}
              </div>
            </div>
          );
          break;
        case 'discount':
          badge = (
            <div className="paymentPeriod-badge paymentPeriod-badge--savings">
              <div className="paymentPeriod-badgeText">
                {`- ${termData.campaign.discount}`}
              </div>
            </div>
          );
          break;
        default:
          badge = '';
      }
    }

    const paymentPeriodTime = (
      <div className="paymentPeriod-time">
        <div className="paymentPeriod-timeTitle">
          {termData.title}
          <span className="paymentPeriod-subtitle">
            {termData.subtitle}
          </span>
        </div>
      </div>
    );

    const paymentPeriodPriceTranslation = `${get(globals, 'currency', '')}/${get(translations, 'txt: mēnesī', 'mēnesī')}`;
    let paymentPeriodPriceClassName = 'paymentPeriod-price';
    let paymentPeriodPriceTitle = (
      <div className="paymentPeriod-priceTitle">
        {termData.pricePerMonth.toFixed(2)}
        <span className="paymentPeriod-subtitle pls">
          {paymentPeriodPriceTranslation}
        </span>
      </div>
    );

    if (termData.campaign) {
      paymentPeriodPriceClassName += ' paymentPeriod-price--special';
      paymentPeriodPriceTitle = (
        <div className="paymentPeriod-priceTitle">
          <span className="tcr">
            {termData.campaign.pricePerMonth.toFixed(2)}
          </span>
          <span className="paymentPeriod-subtitle pls">
            {paymentPeriodPriceTranslation}
            <p className="paymentPeriod-subtitle tdlt">
              {`${termData.pricePerMonth.toFixed(2)} ${paymentPeriodPriceTranslation}`}
            </p>
          </span>
        </div>
      );
    }

    const paymentPeriodPrice = (
      <div className={paymentPeriodPriceClassName}>
        {paymentPeriodPriceTitle}
      </div>
    );

    const paymentPeriodConfirm = (
      <button type="button" className="btn btn--b btn--iconLeft paymentPeriod-confirm">
        <span>{get(translations, 'txt: Izvēlēties', 'Izvēlēties')}</span>
        <span className="btn-static">
          <span className="vcenter">
            <span className="vcenter-inner">
              <svg className="icon icon--check-1">
                <use xlinkHref="#icon-check-1" />
              </svg>
            </span>
          </span>
        </span>
      </button>
    );

    const paymentPeriodSelected = (
      <span className="paymentPeriod-selected">
        <svg className="icon icon--full icon--check-2">
          <use xlinkHref="#icon-check-2" />
        </svg>
      </span>
    );

    let paymentPeriodClassName = 'paymentPeriod';
    let seperator = null;
    if (termData.type === 'sms') {
      paymentPeriodClassName += ' paymentPeriod--sms';
      seperator = <span className="paymentPeriod-separator" key={keyBase + counter} />;
      counter += 1;
    }
    if (chosenOption && chosenOption === payment) {
      paymentPeriodClassName += ' is-active';
    }
    if (index < paymentTypes.length - 1) {
      paymentPeriodClassName += ' mrm';
    }

    const readyResult = (
      <div
        role="button"
        className={paymentPeriodClassName}
        onClick={() => { PaymentsStore.setActive(payment); }}
        onKeyDown={() => { PaymentsStore.setActive(payment); }}
        tabIndex={counter}
        key={keyBase + counter}
      >
        {badge}
        {paymentPeriodTime}
        {paymentPeriodPrice}
        {paymentPeriodConfirm}
        {paymentPeriodSelected}
      </div>
    );

    result.push(readyResult);

    if (seperator) {
      result.push(seperator);
    }

    counter += 1;
  });

  return (
    <div className="paymentPeriod-container">
      {result}
    </div>
  );
};

SubscriptionBlocks.propTypes = {
  termsData: PropTypes.instanceOf(Object).isRequired,
  chosenOption: PropTypes.string,
};
SubscriptionBlocks.defaultProps = {
  chosenOption: null,
};

export default SubscriptionBlocks;
